import { httpV2 } from "../../apis/http"
import URL_API from "../../apis/urlApi"
import { handleGetTeamId } from "../helpers"
import { TaskTypeEditMemberAccessPayloadProps, TaskTypeEditMemberAccessResponseProps, TaskTypeListPayloadProps, TaskTypeListResponseProps, TaskTypeMemberAccessListPayloadProps, TaskTypeMemberAccessListResponseProps, UpdateFillTaskTimePayloadProps, UpdateFillTaskTimeResponseProps } from "./taskTypeService.interface"

const taskTypeService = {
  list: async function (body: TaskTypeListPayloadProps) {
    try {
      const team = handleGetTeamId()
      const payload = {
        profile_id: team,
        ...body,
      }
      const response = await httpV2(true).post<TaskTypeListResponseProps>(URL_API.TASK_TYPE_LIST, payload)
      return response.data
    } catch (error) {
      throw 'error get task type list'
    }
  },
  memberAccessList: async function (body: TaskTypeMemberAccessListPayloadProps) {
    try {
      const team = handleGetTeamId()
      const payload = {
        profile_id: team,
        ...body,
      }
      const response = await httpV2(true).post<TaskTypeMemberAccessListResponseProps>(URL_API.TASK_TYPE_MEMBER_ACCESS_LIST, payload)
      return response.data
    } catch (error) {
      throw 'error get task type member access list'
    }
  },
  editMemberAccess: async function (body: TaskTypeEditMemberAccessPayloadProps) {
    try {
      const team = handleGetTeamId()
      const payload = {
        profile_id: team,
        ...body,
        members: JSON.stringify(body?.members)
      }
      const response = await httpV2(true).post<TaskTypeEditMemberAccessResponseProps>(URL_API.EDIT_TASK_TYPE_MEMBER_ACCESS, payload)
      return response.data
    } catch (error) {
      throw 'error edit task type member access'
    }
  },
  updateFillTaskTime: async function (body: UpdateFillTaskTimePayloadProps) {
    try {
      const team = handleGetTeamId()
      const payload = {
        profile_id: team,
        ...body,
      }
      const response = await httpV2(true).post<UpdateFillTaskTimeResponseProps>(URL_API.EDIT_FILL_TASK_TIME, payload)
      return response.data
    } catch (error) {
      throw 'error edit fill task time'
    }
  },
}

export default taskTypeService